import { render } from "./PatientTags.vue?vue&type=template&id=5757d93e&ts=true"
import script from "./PatientTags.ts?vue&type=script&lang=ts&external"
export * from "./PatientTags.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__